import { render, staticRenderFns } from "./PageList.vue?vue&type=template&id=262981bb&scoped=true"
import script from "./PageList.vue?vue&type=script&lang=js"
export * from "./PageList.vue?vue&type=script&lang=js"
import style0 from "./PageList.vue?vue&type=style&index=0&id=262981bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262981bb",
  null
  
)

export default component.exports